import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AlertType = {
  id: number;
  message: string;
};

type AlertState = {
  alerts: AlertType[];
};

const initialState: AlertState = {
  alerts: [],
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    addAlert: (state, action: PayloadAction<string>) => {
      const id = Date.now();
      state.alerts.push({ id, message: action.payload });
    },
    removeAlert: (state, action: PayloadAction<number>) => {
      state.alerts = state.alerts.filter(
        (notif) => notif.id !== action.payload
      );
    },
  },
});

export const { addAlert, removeAlert } = alertSlice.actions;
export default alertSlice.reducer;
